import PageContainer from '@Guidelines/Layout/PageContainer';
import DocumentGroupListContent from '@UI/Pages/Administration/DocumentGroups/DocumentGroupList/DocumentGroupListContent';
import DocumentGroupsNotifications from '@UI/Pages/Administration/DocumentGroups/Shared/DocumentGroupsNotifications';
import type * as React from 'react';

/** Assembles the screen: the data-owning list and the notifications shared with the editor. */
const DocumentGroupListPage: React.FC = () => {
	return (
		<PageContainer width="md">
			<DocumentGroupListContent />
			<DocumentGroupsNotifications />
		</PageContainer>
	);
};

export default DocumentGroupListPage;
